import { useEffect, useState } from 'react'

/**
 * Tracks `window.innerWidth` and re-renders on `resize`.
 *
 * **Call once per page** and prop-drill the result to consumers. Each invocation
 * registers its own `resize` listener and owns its own state, so N call sites
 * mean N listeners updating N copies of the same value. Yard pages call this
 * in `Yard.tsx` and pass `viewportWidth: number` down — do not call it inside
 * child components or other hooks.
 */
export const useViewportWidth = (): number => {
  const [width, setWidth] = useState(() => window.innerWidth)
  useEffect(() => {
    const handler = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])
  return width
}
